const workshopReducer = (state, action) => {
  switch (action.type) {
    case 'SET_WORKSHOPS':
      return {
        ...state,
        workshops: action.payload,
        selectedWorkshop: null
      };
    case 'EMPTY_WORKSHOPS':
      return {
        ...state,
        workshops: null,
        selectedWorkshop: null
      };
    case 'SELECT_WORKSHOP':
      return {
        ...state,
        selectedWorkshop: action.payload,
      };
    case 'EMPTY_SELECTED_WORKSHOP':
      return {
        ...state,
        selectedWorkshop: null,
      };
    default:
      return state;
  }
}   

export default workshopReducer;
